var map = {
	"./All Magic Items.pdf": 1687,
	"./AllMagicItems.pdf": 9479,
	"./Armor and Weapons.pdf": 1118,
	"./Artifacts.pdf": 7203,
	"./Magic Items Table.pdf": 6230,
	"./Magic Rings.pdf": 1625,
	"./MagicItemsTable.pdf": 721,
	"./Miscellaneous Magic.pdf": 2323,
	"./Potions.pdf": 7376,
	"./Rods Staffs Wands.pdf": 4371,
	"./Scrolls.pdf": 1656
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7782;